import React, { useMemo } from "react";
import "./Product_overview.css";
import { Col, Nav, Row, Tab } from "react-bootstrap";
import parse from "html-react-parser";

function Product_overview({ product }) {
  const hasContent = (html) => {
    if (!html) return false;
    const cleaned = html
      .replace(/<[^>]+>/g, "") // remove HTML tags
      .replace(/&nbsp;/g, "") // remove non-breaking spaces
      .trim();
    return cleaned.length > 0;
  };

  // ✅ Show tab only if status is true AND content is valid
  const tabs = useMemo(() => {
    return [
      {
        key: "overview",
        status: true,
        label: "Product Description",
        content: product?.description,
      },
      {
        key: "composition",
        status: true,
        label: "Product Details",
        content: "1",
      },
    ].filter((t) => t.status === true && hasContent(t.content)); // ✅ only show if status true AND has content
  }, [product]);

  const defaultActiveKey = tabs.length > 0 ? tabs[0].key : null;

  return (
    <section className="Product_overview">
      <div>
        {tabs.length > 0 ? (
          <div className="Product_overview_tabs">
            <Tab.Container
              id="product-tabs"
              defaultActiveKey={defaultActiveKey}
            >
              <Nav variant="pills" className="flex tabs_holder">
                {tabs.map((tab) => (
                  <Nav.Item key={tab.key}>
                    <Nav.Link eventKey={tab.key}>{tab.label}</Nav.Link>
                  </Nav.Item>
                ))}
              </Nav>

              <Tab.Content className="tab_content_holder">
                {tabs.map((tab) => (
                  <Tab.Pane key={tab.key} eventKey={tab.key}>
                    {tab.key === "composition" ? (
                      <div className="composition_details">
                        <Row>
                          <Col xs={4}>
                            <strong>Brand:</strong>
                          </Col>
                          <Col xs={8}>{product?.Brand?.name || "N/A"}</Col>
                        </Row>

                        <Row>
                          <Col xs={4}>
                            <strong>SKU:</strong>
                          </Col>
                          <Col xs={8}>{product?.item_code || "N/A"}</Col>
                        </Row>

                        <Row>
                          <Col xs={4}>
                            <strong>Tag:</strong>
                          </Col>
                          <Col xs={8}>{product?.tag || "N/A"}</Col>
                        </Row>

                        <Row>
                          <Col xs={4}>
                            <strong>Sub Category:</strong>
                          </Col>
                          <Col xs={8}>
                            {product?.p_sub_category?.name || "N/A"}
                          </Col>
                        </Row>
                        {/* <Row>
                          <Col xs={4}>
                            <strong>MFG Date:</strong>
                          </Col>
                          <Col xs={8}>
                            {product?.p_sub_category?.name || "12 March 2026"}
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={4}>
                            <strong>EXP Date:</strong>
                          </Col>
                          <Col xs={8}>
                            {product?.p_sub_category?.name || "12 March 2026"}
                          </Col>
                        </Row> */}
                      </div>
                    ) : (
                      parse(tab.content)
                    )}
                  </Tab.Pane>
                ))}
              </Tab.Content>
            </Tab.Container>
          </div>
        ) : (
          <p
            className="text-center"
            style={{
              color: "red",
              fontWeight: "500",
              marginTop: "20px",
            }}
          >
            No product details available
          </p>
        )}
      </div>
    </section>
  );
}

export default Product_overview;
